webpackJsonp([114276838955818,60335399758886],{

/***/ 88:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Dismocan.com"}}},"layoutContext":{}}

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(169);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(88);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	    var location = _ref.location;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)('footer', { 'footer--light': location.pathname === '/' }),
	            style: { paddingTop: '30px' }
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'credits', style: { marginTop: '0px' } },
	            _react2.default.createElement(
	                'p',
	                { style: { paddingTop: '0px' } },
	                'Copyright \xA9 ',
	                new Date().getFullYear(),
	                '. Todos los derechos reservados - Dismocan'
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _logoHeader = __webpack_require__(360);
	
	var _logoHeader2 = _interopRequireDefault(_logoHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	    var location = _ref.location;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: (0, _classnames2.default)('navbar', 'navbar-dark', 'navbar-expand-lg', { 'bg-transparent': location.pathname === '/' }),
	            role: 'banner'
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            ' ',
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'navbar-brand', to: '/' },
	                location.pathname !== '/' && _react2.default.createElement('img', { src: _logoHeader2.default }),
	                location.pathname === '/' && 'Dismocan'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'navbar-toggler', 'data-toggle': 'collapse', 'data-target': '#navbar-collapse' },
	                _react2.default.createElement('span', { className: 'navbar-toggler-icon' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'collapse navbar-collapse justify-content-end', id: 'navbar-collapse' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'navbar-nav' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item dropdown' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/', className: 'nav-link' },
	                            'Inicio'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'navbar-nav' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item dropdown' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'nav-link dropdown-toggle', 'data-toggle': 'dropdown', style: { cursor: 'pointer ' } },
	                            'Soluciones t\xE9cnicas',
	                            _react2.default.createElement('i', { className: 'ion-chevron-down' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'dropdown-menu' },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'dropdown-item', to: '/soluciones-tecnicas/humedades' },
	                                'Humedades'
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'dropdown-item', to: '/soluciones-tecnicas/morteros-tecnicos' },
	                                'Morteros t\xE9cnicos'
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'dropdown-item', to: '/soluciones-tecnicas/decoracion' },
	                                'Decoraci\xF3n'
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'dropdown-item', to: '/soluciones-tecnicas/pintura' },
	                                'Pintura'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'navbar-nav' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item dropdown' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/quienes-somos', className: 'nav-link' },
	                            'Quienes somos'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'navbar-nav' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item dropdown' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/contacto', className: 'nav-link' },
	                            'Contacto'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(267);
	
	__webpack_require__(269);
	
	__webpack_require__(268);
	
	var _Header = __webpack_require__(168);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(167);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _favicon = __webpack_require__(355);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	    var children = _ref.children,
	        data = _ref.data,
	        location = _ref.location;
	    return _react2.default.createElement(
	        'div',
	        { className: 'main-wrapper' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            { titleTemplate: '%s - ' + data.site.siteMetadata.title },
	            _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no' }),
	            _react2.default.createElement('link', { href: _favicon2.default, rel: 'shortcut icon', type: 'image/x-icon' }),
	            _react2.default.createElement('script', { src: '/theme.min.js' }),
	            _react2.default.createElement('html', { lang: 'es' })
	        ),
	        _react2.default.createElement(_Header2.default, { location: location }),
	        children(),
	        _react2.default.createElement(_Footer2.default, { location: location })
	    );
	};
	
	Layout.propTypes = {
	    children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-80a56e17e52a5ab7c5dc.js